/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as OperationsRouteImport } from './routes/operations'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as BrandsRouteImport } from './routes/brands'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BrandsIndexRouteImport } from './routes/brands.index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as LegalTermsRouteImport } from './routes/legal.terms'
import { Route as LegalPrivacyRouteImport } from './routes/legal.privacy'
import { Route as BrandsElzaryRouteImport } from './routes/brands.elzary'
import { Route as BrandsAvyraatlasRouteImport } from './routes/brands.avyraatlas'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AdminPostsRouteImport } from './routes/admin.posts'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as AdminContactsRouteImport } from './routes/admin.contacts'
import { Route as AdminPostsIndexRouteImport } from './routes/admin.posts.index'
import { Route as AdminPostsNewRouteImport } from './routes/admin.posts.new'
import { Route as AdminPostsCategoriesRouteImport } from './routes/admin.posts.categories'
import { Route as AdminPostsPostIdEditRouteImport } from './routes/admin.posts.$postId.edit'

const ServicesRoute = ServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => rootRouteImport,
} as any)
const OperationsRoute = OperationsRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRoute = LegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandsRoute = BrandsRouteImport.update({
  id: '/brands',
  path: '/brands',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogRoute = BlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandsIndexRoute = BrandsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BrandsRoute,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BlogRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const LegalTermsRoute = LegalTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => LegalRoute,
} as any)
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => LegalRoute,
} as any)
const BrandsElzaryRoute = BrandsElzaryRouteImport.update({
  id: '/elzary',
  path: '/elzary',
  getParentRoute: () => BrandsRoute,
} as any)
const BrandsAvyraatlasRoute = BrandsAvyraatlasRouteImport.update({
  id: '/avyraatlas',
  path: '/avyraatlas',
  getParentRoute: () => BrandsRoute,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => BlogRoute,
} as any)
const AdminPostsRoute = AdminPostsRouteImport.update({
  id: '/posts',
  path: '/posts',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContactsRoute = AdminContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPostsIndexRoute = AdminPostsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminPostsRoute,
} as any)
const AdminPostsNewRoute = AdminPostsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AdminPostsRoute,
} as any)
const AdminPostsCategoriesRoute = AdminPostsCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AdminPostsRoute,
} as any)
const AdminPostsPostIdEditRoute = AdminPostsPostIdEditRouteImport.update({
  id: '/$postId/edit',
  path: '/$postId/edit',
  getParentRoute: () => AdminPostsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRouteWithChildren
  '/blog': typeof BlogRouteWithChildren
  '/brands': typeof BrandsRouteWithChildren
  '/legal': typeof LegalRouteWithChildren
  '/operations': typeof OperationsRoute
  '/services': typeof ServicesRoute
  '/admin/contacts': typeof AdminContactsRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/posts': typeof AdminPostsRouteWithChildren
  '/blog/$slug': typeof BlogSlugRoute
  '/brands/avyraatlas': typeof BrandsAvyraatlasRoute
  '/brands/elzary': typeof BrandsElzaryRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
  '/admin/': typeof AdminIndexRoute
  '/blog/': typeof BlogIndexRoute
  '/brands/': typeof BrandsIndexRoute
  '/admin/posts/categories': typeof AdminPostsCategoriesRoute
  '/admin/posts/new': typeof AdminPostsNewRoute
  '/admin/posts/': typeof AdminPostsIndexRoute
  '/admin/posts/$postId/edit': typeof AdminPostsPostIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/legal': typeof LegalRouteWithChildren
  '/operations': typeof OperationsRoute
  '/services': typeof ServicesRoute
  '/admin/contacts': typeof AdminContactsRoute
  '/admin/login': typeof AdminLoginRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/brands/avyraatlas': typeof BrandsAvyraatlasRoute
  '/brands/elzary': typeof BrandsElzaryRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
  '/admin': typeof AdminIndexRoute
  '/blog': typeof BlogIndexRoute
  '/brands': typeof BrandsIndexRoute
  '/admin/posts/categories': typeof AdminPostsCategoriesRoute
  '/admin/posts/new': typeof AdminPostsNewRoute
  '/admin/posts': typeof AdminPostsIndexRoute
  '/admin/posts/$postId/edit': typeof AdminPostsPostIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRouteWithChildren
  '/blog': typeof BlogRouteWithChildren
  '/brands': typeof BrandsRouteWithChildren
  '/legal': typeof LegalRouteWithChildren
  '/operations': typeof OperationsRoute
  '/services': typeof ServicesRoute
  '/admin/contacts': typeof AdminContactsRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/posts': typeof AdminPostsRouteWithChildren
  '/blog/$slug': typeof BlogSlugRoute
  '/brands/avyraatlas': typeof BrandsAvyraatlasRoute
  '/brands/elzary': typeof BrandsElzaryRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
  '/admin/': typeof AdminIndexRoute
  '/blog/': typeof BlogIndexRoute
  '/brands/': typeof BrandsIndexRoute
  '/admin/posts/categories': typeof AdminPostsCategoriesRoute
  '/admin/posts/new': typeof AdminPostsNewRoute
  '/admin/posts/': typeof AdminPostsIndexRoute
  '/admin/posts/$postId/edit': typeof AdminPostsPostIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/admin'
    | '/blog'
    | '/brands'
    | '/legal'
    | '/operations'
    | '/services'
    | '/admin/contacts'
    | '/admin/login'
    | '/admin/posts'
    | '/blog/$slug'
    | '/brands/avyraatlas'
    | '/brands/elzary'
    | '/legal/privacy'
    | '/legal/terms'
    | '/admin/'
    | '/blog/'
    | '/brands/'
    | '/admin/posts/categories'
    | '/admin/posts/new'
    | '/admin/posts/'
    | '/admin/posts/$postId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/legal'
    | '/operations'
    | '/services'
    | '/admin/contacts'
    | '/admin/login'
    | '/blog/$slug'
    | '/brands/avyraatlas'
    | '/brands/elzary'
    | '/legal/privacy'
    | '/legal/terms'
    | '/admin'
    | '/blog'
    | '/brands'
    | '/admin/posts/categories'
    | '/admin/posts/new'
    | '/admin/posts'
    | '/admin/posts/$postId/edit'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/admin'
    | '/blog'
    | '/brands'
    | '/legal'
    | '/operations'
    | '/services'
    | '/admin/contacts'
    | '/admin/login'
    | '/admin/posts'
    | '/blog/$slug'
    | '/brands/avyraatlas'
    | '/brands/elzary'
    | '/legal/privacy'
    | '/legal/terms'
    | '/admin/'
    | '/blog/'
    | '/brands/'
    | '/admin/posts/categories'
    | '/admin/posts/new'
    | '/admin/posts/'
    | '/admin/posts/$postId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AdminRoute: typeof AdminRouteWithChildren
  BlogRoute: typeof BlogRouteWithChildren
  BrandsRoute: typeof BrandsRouteWithChildren
  LegalRoute: typeof LegalRouteWithChildren
  OperationsRoute: typeof OperationsRoute
  ServicesRoute: typeof ServicesRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/services': {
      id: '/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof ServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operations': {
      id: '/operations'
      path: '/operations'
      fullPath: '/operations'
      preLoaderRoute: typeof OperationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands': {
      id: '/brands'
      path: '/brands'
      fullPath: '/brands'
      preLoaderRoute: typeof BrandsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog': {
      id: '/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands/': {
      id: '/brands/'
      path: '/'
      fullPath: '/brands/'
      preLoaderRoute: typeof BrandsIndexRouteImport
      parentRoute: typeof BrandsRoute
    }
    '/blog/': {
      id: '/blog/'
      path: '/'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof BlogRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/legal/terms': {
      id: '/legal/terms'
      path: '/terms'
      fullPath: '/legal/terms'
      preLoaderRoute: typeof LegalTermsRouteImport
      parentRoute: typeof LegalRoute
    }
    '/legal/privacy': {
      id: '/legal/privacy'
      path: '/privacy'
      fullPath: '/legal/privacy'
      preLoaderRoute: typeof LegalPrivacyRouteImport
      parentRoute: typeof LegalRoute
    }
    '/brands/elzary': {
      id: '/brands/elzary'
      path: '/elzary'
      fullPath: '/brands/elzary'
      preLoaderRoute: typeof BrandsElzaryRouteImport
      parentRoute: typeof BrandsRoute
    }
    '/brands/avyraatlas': {
      id: '/brands/avyraatlas'
      path: '/avyraatlas'
      fullPath: '/brands/avyraatlas'
      preLoaderRoute: typeof BrandsAvyraatlasRouteImport
      parentRoute: typeof BrandsRoute
    }
    '/blog/$slug': {
      id: '/blog/$slug'
      path: '/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof BlogRoute
    }
    '/admin/posts': {
      id: '/admin/posts'
      path: '/posts'
      fullPath: '/admin/posts'
      preLoaderRoute: typeof AdminPostsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/contacts': {
      id: '/admin/contacts'
      path: '/contacts'
      fullPath: '/admin/contacts'
      preLoaderRoute: typeof AdminContactsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/posts/': {
      id: '/admin/posts/'
      path: '/'
      fullPath: '/admin/posts/'
      preLoaderRoute: typeof AdminPostsIndexRouteImport
      parentRoute: typeof AdminPostsRoute
    }
    '/admin/posts/new': {
      id: '/admin/posts/new'
      path: '/new'
      fullPath: '/admin/posts/new'
      preLoaderRoute: typeof AdminPostsNewRouteImport
      parentRoute: typeof AdminPostsRoute
    }
    '/admin/posts/categories': {
      id: '/admin/posts/categories'
      path: '/categories'
      fullPath: '/admin/posts/categories'
      preLoaderRoute: typeof AdminPostsCategoriesRouteImport
      parentRoute: typeof AdminPostsRoute
    }
    '/admin/posts/$postId/edit': {
      id: '/admin/posts/$postId/edit'
      path: '/$postId/edit'
      fullPath: '/admin/posts/$postId/edit'
      preLoaderRoute: typeof AdminPostsPostIdEditRouteImport
      parentRoute: typeof AdminPostsRoute
    }
  }
}

interface AdminPostsRouteChildren {
  AdminPostsCategoriesRoute: typeof AdminPostsCategoriesRoute
  AdminPostsNewRoute: typeof AdminPostsNewRoute
  AdminPostsIndexRoute: typeof AdminPostsIndexRoute
  AdminPostsPostIdEditRoute: typeof AdminPostsPostIdEditRoute
}

const AdminPostsRouteChildren: AdminPostsRouteChildren = {
  AdminPostsCategoriesRoute: AdminPostsCategoriesRoute,
  AdminPostsNewRoute: AdminPostsNewRoute,
  AdminPostsIndexRoute: AdminPostsIndexRoute,
  AdminPostsPostIdEditRoute: AdminPostsPostIdEditRoute,
}

const AdminPostsRouteWithChildren = AdminPostsRoute._addFileChildren(
  AdminPostsRouteChildren,
)

interface AdminRouteChildren {
  AdminContactsRoute: typeof AdminContactsRoute
  AdminLoginRoute: typeof AdminLoginRoute
  AdminPostsRoute: typeof AdminPostsRouteWithChildren
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminContactsRoute: AdminContactsRoute,
  AdminLoginRoute: AdminLoginRoute,
  AdminPostsRoute: AdminPostsRouteWithChildren,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface BlogRouteChildren {
  BlogSlugRoute: typeof BlogSlugRoute
  BlogIndexRoute: typeof BlogIndexRoute
}

const BlogRouteChildren: BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,
  BlogIndexRoute: BlogIndexRoute,
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

interface BrandsRouteChildren {
  BrandsAvyraatlasRoute: typeof BrandsAvyraatlasRoute
  BrandsElzaryRoute: typeof BrandsElzaryRoute
  BrandsIndexRoute: typeof BrandsIndexRoute
}

const BrandsRouteChildren: BrandsRouteChildren = {
  BrandsAvyraatlasRoute: BrandsAvyraatlasRoute,
  BrandsElzaryRoute: BrandsElzaryRoute,
  BrandsIndexRoute: BrandsIndexRoute,
}

const BrandsRouteWithChildren =
  BrandsRoute._addFileChildren(BrandsRouteChildren)

interface LegalRouteChildren {
  LegalPrivacyRoute: typeof LegalPrivacyRoute
  LegalTermsRoute: typeof LegalTermsRoute
}

const LegalRouteChildren: LegalRouteChildren = {
  LegalPrivacyRoute: LegalPrivacyRoute,
  LegalTermsRoute: LegalTermsRoute,
}

const LegalRouteWithChildren = LegalRoute._addFileChildren(LegalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AdminRoute: AdminRouteWithChildren,
  BlogRoute: BlogRouteWithChildren,
  BrandsRoute: BrandsRouteWithChildren,
  LegalRoute: LegalRouteWithChildren,
  OperationsRoute: OperationsRoute,
  ServicesRoute: ServicesRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
